import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { EntityApi } from "src/libs/portal/review/entity";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
:host {
  display: contents;
}

.reviewops-nav {
  color: #303730;
  background: var(--ro-sidebar-canvas, #f7f8f4);
  scrollbar-color: #c8cec2 transparent;
  font-family: Pretendard, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.reviewops-nav__brand {
  border: 0;
  background: #ffffff;
  box-shadow: inset 0 -1px 0 #e3e7de;
}

.reviewops-nav__logo,
.reviewops-nav__logo img {
  border: 0;
  background: transparent;
  box-shadow: none;
  filter: none;
}

.reviewops-nav__eyebrow {
  color: #8a9286;
  font-weight: 600;
  letter-spacing: 0.06em;
}

.reviewops-nav__group {
  position: relative;
  display: grid;
  gap: 4px;
  margin: 0;
  padding: 0 0 0 16px;
  list-style: none;
}

.reviewops-nav__group::before {
  content: "";
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 4px;
  width: 1px;
  background: var(--ro-line, #d9dfd7);
  pointer-events: none;
}

.reviewops-nav__menu > .reviewops-nav__group + .reviewops-nav__eyebrow {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid var(--ro-line, #d9dfd7);
}

.nav-link {
  position: relative;
  border: 1px solid transparent;
  border-radius: 8px !important;
  text-decoration: none;
  transition: color 140ms ease, background-color 140ms ease, box-shadow 140ms ease;
}

.nav-link::before {
  display: none;
}

.nav-link--active {
  color: #a83f23;
  background: #fff0e9;
  border: 1px solid #eadfd7;
  box-shadow: none;
}

.nav-link--active > svg {
  color: #e86135;
}

.nav-link--idle {
  color: #4f594d;
}

.nav-link--idle > svg {
  color: #737d70;
}

.nav-link--idle:hover {
  color: #252c24;
  background: #ecefe8;
}

.nav-link--idle:hover > svg {
  color: #495347;
}

.reviewops-nav__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 22px;
  margin-left: 0;
  padding: 0 6px;
  border-radius: 6px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: #5f695d;
  background: #e8ece4;
  box-shadow: none;
}

.nav-link--active .reviewops-nav__count {
  color: #ffffff;
  background: #e86135;
}

.reviewops-nav__profile {
  border: 0;
  border-radius: 8px !important;
  background: #ffffff;
  box-shadow: inset 0 0 0 1px #e1e5dc;
  backdrop-filter: none;
}

.reviewops-nav__avatar {
  color: #ffffff;
  border-radius: 6px !important;
  background: #78952b;
  box-shadow: none;
}

.reviewops-nav__name {
  color: #252b24;
}

.reviewops-nav__email {
  color: #7a8378;
}

.reviewops-nav__profile-link {
  color: #5d675b;
  border-radius: 5px !important;
  transition: color 140ms ease, background-color 140ms ease;
}

.reviewops-nav__profile-link:hover,
.reviewops-nav__profile-link--active {
  color: #9f3d22;
  background: #fff0e9;
}

.role-badge--admin {
  color: #ad4325;
  background: #fff0e8;
}

.role-badge--user {
  color: #4f6542;
  background: #eaf0e4;
}

.reviewops-nav .border-white\/10 {
  border-color: #e3e7de;
}

.operator-toast-stack {
  position: fixed;
  z-index: 130;
  top: 22px;
  right: 24px;
  display: grid;
  width: min(380px, 100vw - 32px);
  gap: 9px;
  pointer-events: none;
}

.operator-toast {
  display: grid;
  min-height: 72px;
  grid-template-columns: 34px minmax(0, 1fr) 28px;
  align-items: start;
  gap: 10px;
  padding: 13px 11px 12px 13px;
  border: 1px solid #9fcec0;
  border-left: 4px solid #268067;
  border-radius: 7px;
  background: #f4fbf8;
  box-shadow: 0 14px 34px rgba(27, 52, 44, 0.17);
  color: #20362f;
  cursor: pointer;
  pointer-events: auto;
  transition: border-color 0.14s ease, box-shadow 0.14s ease, transform 0.14s ease;
  animation: operator-toast-in 0.22s ease-out;
}

.operator-toast:hover {
  border-color: #70b4a1;
  box-shadow: 0 16px 38px rgba(27, 52, 44, 0.21);
  transform: translateY(-1px);
}

.operator-toast:focus-visible {
  outline: 2px solid rgba(38, 128, 103, 0.34);
  outline-offset: 2px;
}

.operator-toast[data-level=error] {
  border-color: #e5b5b2;
  border-left-color: #c84842;
  background: #fff5f4;
  color: #542724;
}

.operator-toast__icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #dcefe8;
  color: #26755f;
}

.operator-toast[data-level=error] .operator-toast__icon {
  background: #f8dcda;
  color: #b63f39;
}

.operator-toast > div {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.operator-toast strong {
  font-size: 12px;
}

.operator-toast p {
  margin: 0;
  color: #5d7169;
  font-size: 10px;
  line-height: 1.5;
}

.operator-toast[data-level=error] p {
  color: #76534f;
}

.operator-toast > button {
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: inherit;
  opacity: 0.65;
}

.operator-toast > button:hover {
  background: rgba(0, 0, 0, 0.05);
  opacity: 1;
}

@keyframes operator-toast-in {
  from {
    opacity: 0;
    transform: translateX(18px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.floating-ai-launcher {
  position: fixed;
  z-index: 80;
  right: 26px;
  bottom: 26px;
  display: inline-flex;
  width: 56px;
  height: 56px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #175947;
  border-radius: 50%;
  background: #216f5c;
  box-shadow: 0 12px 30px rgba(25, 72, 59, 0.3), 0 0 0 4px rgba(255, 255, 255, 0.9);
  color: #fff;
  font-family: inherit;
  font-size: 18px;
  transition: transform 0.16s ease, background-color 0.16s ease, box-shadow 0.16s ease;
}

.floating-ai-launcher > span {
  position: absolute;
  right: calc(100% + 10px);
  display: inline-flex;
  min-width: max-content;
  height: 32px;
  align-items: center;
  padding: 0 10px;
  border: 1px solid #d3dcdf;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 7px 20px rgba(29, 43, 51, 0.13);
  color: #293940;
  font-size: 10px;
  font-weight: 850;
}

.floating-ai-launcher > em {
  position: absolute;
  top: 1px;
  right: 1px;
  width: 11px;
  height: 11px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #eb6a43;
}

.floating-ai-launcher:hover {
  transform: translateY(-2px);
  background: #185e4d;
  box-shadow: 0 16px 34px rgba(25, 72, 59, 0.34), 0 0 0 4px rgba(255, 255, 255, 0.94);
}

.floating-ai-launcher:focus-visible {
  outline: 3px solid rgba(38, 121, 95, 0.28);
  outline-offset: 4px;
}

.floating-ai {
  position: fixed;
  z-index: 90;
  right: 24px;
  bottom: 22px;
  display: grid;
  width: 390px;
  height: min(560px, 100vh - 44px);
  overflow: hidden;
  grid-template-rows: auto auto minmax(0, 1fr) auto;
  border: 1px solid #cfd9dd;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 18px 50px rgba(29, 43, 51, 0.2);
  color: #1d2a32;
  font-family: Pretendard, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.floating-ai__header {
  grid-row: 1;
}

.floating-ai__context {
  grid-row: 2;
  min-width: 0;
}

.floating-ai__conversation {
  grid-row: 3;
}

.floating-ai__composer {
  grid-row: 4;
}

.floating-ai__header,
.floating-ai__header > div:first-child,
.floating-ai__header-actions,
.floating-ai__answer > header,
.floating-ai__proposal > header,
.floating-ai__proposal > header > div,
.floating-ai__proposal footer,
.floating-ai__error,
.floating-ai__input {
  display: flex;
  align-items: center;
}

.floating-ai__header {
  min-height: 58px;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px 10px 14px;
  border-bottom: 1px solid #e1e7e9;
}

.floating-ai__header > div:first-child {
  min-width: 0;
  gap: 9px;
}

.floating-ai__header > div:first-child > div {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.floating-ai__header h2 {
  margin: 0;
  font-size: 13px;
  line-height: 1.3;
  letter-spacing: 0;
}

.floating-ai__header p {
  overflow: hidden;
  margin: 0;
  color: #77858c;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.floating-ai__mark {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: #e5f2ee;
  color: #236e5b;
}

.floating-ai__header-actions {
  gap: 4px;
}

.floating-ai__header-actions button,
.floating-ai__header-actions a {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: #66757d;
  font-size: 11px;
}

.floating-ai__header-actions button:hover,
.floating-ai__header-actions a:hover {
  background: #eef2f3;
  color: #1e6654;
}

.floating-ai__project-picker {
  display: grid;
  min-width: 0;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-bottom: 1px solid #e1e7e9;
  background: #f8fbfa;
  color: #4d6068;
  font-size: 9px;
  font-weight: 800;
}

.floating-ai__project-picker > span:first-child {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}

.floating-ai__project-picker > span:first-child i {
  color: #26705d;
}

.floating-ai__project-select {
  position: relative;
  min-width: 0;
}

.floating-ai__project-select select {
  width: 100%;
  height: 32px;
  appearance: none;
  overflow: hidden;
  padding: 0 28px 0 9px;
  border: 1px solid #cbd6da;
  border-radius: 5px;
  outline: 0;
  background: #fff;
  color: #25343c;
  font: inherit;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.floating-ai__project-select select:focus {
  border-color: #6d9f92;
  box-shadow: 0 0 0 2px rgba(42, 126, 104, 0.1);
}

.floating-ai__project-select select:disabled {
  background: #eef2f3;
  color: #77858c;
}

.floating-ai__project-select i {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: #6f7e85;
  font-size: 7px;
  pointer-events: none;
}

.floating-ai__error {
  gap: 7px;
  padding: 8px 11px;
  border-bottom: 1px solid #efc5c2;
  background: #fff2f1;
  color: #a23834;
  font-size: 9px;
}

.floating-ai__error span {
  flex: 1;
}

.floating-ai__error button {
  border: 0;
  background: transparent;
  color: inherit;
}

.floating-ai__conversation {
  min-height: 0;
  overflow-y: auto;
  padding: 14px 14px 18px;
  background: #f7f9fa;
  scroll-behavior: smooth;
}

.floating-ai__loading,
.floating-ai__answer.is-pending {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #718087;
  font-size: 9px;
}

.floating-ai__empty {
  display: grid;
  min-height: 100%;
  align-content: center;
  justify-items: center;
  padding: 24px 8px;
  text-align: center;
}

.floating-ai__empty > span {
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #e5f2ee;
  color: #236e5b;
}

.floating-ai__empty strong {
  margin-top: 11px;
  font-size: 12px;
}

.floating-ai__empty p {
  margin: 5px 0 0;
  color: #7b888f;
  font-size: 9px;
  line-height: 1.5;
}

.floating-ai__empty button {
  display: flex;
  width: 100%;
  min-height: 40px;
  align-items: center;
  gap: 7px;
  margin-top: 16px;
  padding: 8px 10px;
  border: 1px solid #d3dcdf;
  border-radius: 6px;
  background: #fff;
  color: #42535c;
  font-size: 9px;
  font-weight: 750;
  text-align: left;
}

.floating-ai__empty button i {
  color: #28745f;
}

.floating-ai__exchange + .floating-ai__exchange {
  margin-top: 18px;
}

.floating-ai__request {
  max-width: 84%;
  margin-left: auto;
  padding: 9px 10px;
  border-radius: 7px 7px 2px 7px;
  background: #294354;
  color: #fff;
}

.floating-ai__request em {
  display: block;
  margin-bottom: 3px;
  color: #c9d7df;
  font-size: 8px;
  font-style: normal;
  font-weight: 750;
}

.floating-ai__request p,
.floating-ai__answer > p {
  margin: 0;
  white-space: pre-wrap;
  font-size: 10px;
  line-height: 1.55;
}

.floating-ai__request-files,
.floating-ai__attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.floating-ai__request-files {
  margin-top: 7px;
}

.floating-ai__request-files span,
.floating-ai__attachments span {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 5px;
  border-radius: 5px;
  font-size: 8px;
}

.floating-ai__request-files span {
  max-width: 100%;
  padding: 4px 6px;
  background: rgba(255, 255, 255, 0.14);
  color: #eef5f7;
}

.floating-ai__request-files i,
.floating-ai__attachments i {
  flex: 0 0 auto;
}

.floating-ai__direct-action {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  gap: 6px;
  margin-top: 9px;
  padding: 0 10px;
  border: 1px solid #216f5c;
  border-radius: 5px;
  background: #216f5c;
  color: #fff;
  cursor: pointer;
  font: inherit;
  font-size: 8px;
  font-weight: 800;
}

.floating-ai__answer {
  margin-top: 8px;
  padding: 11px;
  border: 1px solid #d8e0e3;
  border-left: 3px solid #2b7965;
  border-radius: 2px 7px 7px 7px;
  background: #fff;
}

.floating-ai__answer[data-severity=warning] {
  border-left-color: #bf7b27;
}

.floating-ai__answer[data-severity=critical] {
  border-left-color: #b33d39;
}

.floating-ai__answer > header {
  gap: 6px;
  margin-bottom: 7px;
}

.floating-ai__answer > header span {
  display: inline-flex;
  width: 23px;
  height: 23px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: #e5f2ee;
  color: #236e5b;
  font-size: 9px;
}

.floating-ai__answer > header strong {
  font-size: 9px;
}

.floating-ai__answer > header em {
  margin-left: auto;
  padding: 2px 5px;
  border-radius: 4px;
  background: #edf2f4;
  color: #66757d;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.floating-ai__answer ul {
  display: grid;
  gap: 7px;
  margin: 9px 0 0;
  padding: 9px 0 0;
  border-top: 1px solid #e4e9eb;
  list-style: none;
}

.floating-ai__answer li {
  display: grid;
  gap: 2px;
}

.floating-ai__answer li strong {
  font-size: 8px;
}

.floating-ai__answer li span {
  color: #39705f;
  font-size: 8px;
}

.floating-ai__answer.is-pending {
  border-left-color: #718087;
}

.floating-ai__proposal {
  margin-top: 11px;
  padding-top: 10px;
  border-top: 1px solid #cedbd8;
}

.floating-ai__proposal > header {
  justify-content: space-between;
  gap: 8px;
}

.floating-ai__proposal > header > div {
  min-width: 0;
  gap: 6px;
}

.floating-ai__proposal > header span {
  flex: 0 0 auto;
  color: #26705d;
  font-size: 7px;
  font-weight: 850;
}

.floating-ai__proposal > header strong {
  overflow: hidden;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.floating-ai__proposal > header em {
  flex: 0 0 auto;
  padding: 2px 5px;
  border-radius: 4px;
  background: #fff0dc;
  color: #986018;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.floating-ai__proposal > p {
  margin: 6px 0 0;
  color: #617078;
  font-size: 8px;
  line-height: 1.5;
}

.floating-ai__proposal footer {
  justify-content: flex-end;
  gap: 5px;
  margin-top: 9px;
}

.floating-ai__proposal footer button {
  min-height: 29px;
  padding: 0 9px;
  border: 1px solid #cbd5d9;
  border-radius: 5px;
  background: #fff;
  color: #475760;
  font-size: 8px;
  font-weight: 800;
}

.floating-ai__proposal footer button.is-primary {
  border-color: #216f5c;
  background: #216f5c;
  color: #fff;
}

.floating-ai__proposal footer button.is-primary.is-danger {
  border-color: #b13b3b;
  background: #b13b3b;
}

.floating-ai__proposal footer button i {
  margin-right: 4px;
}

.floating-ai__composer {
  display: grid;
  gap: 7px;
  padding: 9px 11px 10px;
  border-top: 1px solid #e0e6e8;
  background: #fff;
}

.floating-ai__attachments span {
  max-width: 100%;
  padding: 5px 6px 5px 8px;
  background: #edf3f1;
  color: #40545c;
}

.floating-ai__attachments em {
  overflow: hidden;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.floating-ai__attachments button {
  display: inline-flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #697a81;
}

.floating-ai__input {
  align-items: flex-end;
  gap: 7px;
  padding: 7px 7px 7px 10px;
  border: 1px solid #cbd6da;
  border-radius: 7px;
  background: #fff;
}

.floating-ai__input:focus-within {
  border-color: #6d9f92;
  box-shadow: 0 0 0 2px rgba(42, 126, 104, 0.1);
}

.floating-ai__attach {
  display: inline-flex;
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  color: #60737b;
  cursor: pointer;
}

.floating-ai__attach:hover {
  background: #edf3f1;
  color: #216f5c;
}

.floating-ai__attach.is-loading {
  cursor: wait;
}

.floating-ai__attach input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

.floating-ai .floating-ai__input > textarea {
  width: 100%;
  min-height: 38px;
  max-height: 100px;
  margin: 0 !important;
  resize: none;
  border: 0 !important;
  border-radius: 0 !important;
  outline: 0 !important;
  padding: 3px 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  color: #26353d;
  font: inherit;
  font-size: 9px;
  line-height: 1.5;
}

.floating-ai .floating-ai__input > textarea:focus,
.floating-ai .floating-ai__input > textarea:focus-visible {
  border: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
}

.floating-ai__input button {
  display: inline-flex;
  width: 33px;
  height: 33px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 5px;
  background: #216f5c;
  color: #fff;
}

.floating-ai__input button:disabled {
  background: #d5dcdf;
  color: #849198;
}

.floating-ai__model-picker {
  position: relative;
  justify-self: start;
}

.floating-ai__model-trigger {
  display: inline-flex;
  max-width: 220px;
  min-height: 27px;
  align-items: center;
  gap: 8px;
  padding: 4px 9px;
  border: 1px solid #d8e0e2;
  border-radius: 999px;
  background: #f4f7f6;
  color: #40535b;
  cursor: pointer;
  font-size: 10px;
  font-weight: 750;
}

.floating-ai__model-trigger span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.floating-ai__model-trigger i {
  flex: none;
  font-size: 8px;
}

.floating-ai__model-trigger:hover,
.floating-ai__model-trigger:focus-visible {
  border-color: #90b4a8;
  color: #216f5c;
  outline: none;
}

.floating-ai__model-menu {
  position: absolute;
  z-index: 20;
  bottom: calc(100% + 8px);
  left: 0;
  width: min(280px, 100vw - 46px);
  max-height: min(385px, 60vh);
  overflow-y: auto;
  padding: 8px;
  border: 1px solid #454545;
  border-radius: 16px;
  background: #2c2c2c;
  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.24);
  color: #f5f5f5;
}

.floating-ai__model-heading {
  display: block;
  padding: 5px 11px 8px;
  color: #a7a7a7;
  font-size: 11px;
  font-weight: 750;
}

.floating-ai__model-option {
  display: flex;
  width: 100%;
  min-height: 41px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 11px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: inherit;
  cursor: pointer;
  text-align: left;
}

.floating-ai__model-option:hover,
.floating-ai__model-option:focus-visible {
  background: #414141;
  outline: none;
}

.floating-ai__model-option > span {
  display: grid;
  gap: 2px;
}

.floating-ai__model-option strong {
  font-size: 12px;
  font-weight: 600;
}

.floating-ai__model-option small {
  color: #aaa;
  font-size: 10px;
}

.floating-ai__model-option i {
  color: #c9d3d0;
}

@media (max-width: 700px) {
  .floating-ai-launcher {
    right: 16px;
    bottom: 16px;
    width: 52px;
    height: 52px;
    padding: 0;
    font-size: 16px;
  }
  .floating-ai-launcher > span {
    right: calc(100% + 8px);
    height: 30px;
    padding: 0 9px;
    font-size: 9px;
  }
  .floating-ai {
    right: 12px;
    bottom: 12px;
    width: calc(100% - 24px);
    height: min(560px, 100vh - 24px);
  }
}`],
})
export class ComponentNavSidebarComponent implements OnInit, OnDestroy {
    public projectCount: number = 0;
    public entityProjectCount: number = 0;
    public entityTaskCount: number = 0;
    public qaTaskCount: number = 0;
    public kgTaskCount: number = 0;
    public floatingAssistantOpen: boolean = false;
    public floatingAssistantLoading: boolean = false;
    public floatingAssistantAsking: boolean = false;
    public floatingAssistantMessage: string = '';
    public floatingAssistantError: string = '';
    public floatingAssistantActionId: string = '';
    public floatingAssistantMessages: any[] = [];
    public floatingAttachments: any[] = [];
    public floatingUploadingFile: boolean = false;
    public floatingOperatorOverview: any = { projects: [], surveys: [], harnesses: [], runtime: {} };
    public floatingSelectedProjectId: string = '';
    public floatingSelectedModel: string = '';
    public floatingModelMenuOpen: boolean = false;
    public operatorNotifications: any[] = [];
    private floatingConversationId: string = '';
    private readonly entityUpdatedHandler = () => { void this.loadEntityCounts(); };
    private readonly workspaceStateUrl: string = '/api/v1/review-workspace/state';
    private readonly operatorUrl: string = '/api/v1/review-workspace/operator';
    private readonly operatorFileUrl: string = '/api/v1/review-workspace/operator-file';
    private notificationPollTimer: number | null = null;
    private notificationDismissTimers: Map<string, number> = new Map();
    private floatingConversationByProject: Map<string, string> = new Map();
    private readonly floatingRequestHandler = (event: Event) => {
        const detail = (event as CustomEvent)?.detail || {};
        void this.openFloatingAssistantRequest(
            String(detail.message || ''),
            String(detail.project_id || detail.projectId || ''),
        );
    };
    private readonly floatingModelOutsideHandler = (event: PointerEvent) => {
        if (!this.floatingModelMenuOpen || (event.target instanceof Element && event.target.closest('.floating-ai__model-picker'))) return;
        this.floatingModelMenuOpen = false;
        void this.service.render();
    };
    private readonly floatingModelSelectionHandler = () => {
        this.floatingSelectedModel = this.storedFloatingModel();
        void this.service.render();
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.floatingSelectedModel = this.storedFloatingModel();
        this.floatingConversationId = this.createFloatingConversationId();
        await this.loadWorkspaceCounts();
        await this.loadEntityCounts();
        window.addEventListener('reviewops:entity-updated', this.entityUpdatedHandler);
        window.addEventListener('reviewops:assistant-request', this.floatingRequestHandler);
        window.addEventListener('storage', this.floatingModelSelectionHandler);
        window.addEventListener('reviewops:model-selection-changed', this.floatingModelSelectionHandler);
        document.addEventListener('pointerdown', this.floatingModelOutsideHandler);
        if (this.isAdmin()) {
            await this.pollOperatorNotifications();
            this.notificationPollTimer = window.setInterval(() => void this.pollOperatorNotifications(), 4000);
        }
        await this.service.render();
    }

    public ngOnDestroy() {
        window.removeEventListener('reviewops:entity-updated', this.entityUpdatedHandler);
        window.removeEventListener('reviewops:assistant-request', this.floatingRequestHandler);
        window.removeEventListener('storage', this.floatingModelSelectionHandler);
        window.removeEventListener('reviewops:model-selection-changed', this.floatingModelSelectionHandler);
        document.removeEventListener('pointerdown', this.floatingModelOutsideHandler);
        if (this.notificationPollTimer !== null) window.clearInterval(this.notificationPollTimer);
        this.notificationDismissTimers.forEach((timer: number) => window.clearTimeout(timer));
        this.notificationDismissTimers.clear();
    }

    public async dismissOperatorNotification(notification: any, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        const id = String(notification?.id || '');
        if (!id) return;
        this.operatorNotifications = this.operatorNotifications.filter((item: any) => item.id !== id);
        const timer = this.notificationDismissTimers.get(id);
        if (timer) window.clearTimeout(timer);
        this.notificationDismissTimers.delete(id);
        await this.service.render();
        try {
            await this.postFloatingOperator({ action: 'ack_notification', notification_id: id });
        } catch (error) {
            return;
        }
    }

    public async openOperatorNotification(notification: any, event?: Event) {
        if (event instanceof KeyboardEvent && !['Enter', ' '].includes(event.key)) return;
        if (event?.target instanceof Element && event.target.closest('button')) return;
        event?.preventDefault();
        event?.stopPropagation();
        await this.dismissOperatorNotification(notification);
        location.assign('/qa-operator');
    }

    public showOperatorNotifications() {
        return location.pathname !== '/qa-operator';
    }

    public showFloatingAssistant() {
        if (!this.isAdmin()) return false;
        const path = location.pathname;
        if (/^\/review-projects\/[^/]+\/resource-editor\//.test(path)) return false;
        return (
            path === '/review-projects' || path.indexOf('/review-projects/') === 0
            || path === '/surveys' || path.indexOf('/surveys/') === 0
            || path === '/harnesses' || path.indexOf('/harnesses/') === 0
            || path === '/entity-reviews' || path.indexOf('/entity-reviews/') === 0
            || path === '/human-reviews' || path.indexOf('/human-reviews/') === 0
            || /^\/review-tasks\/qa\//.test(path)
        );
    }

    public async toggleFloatingAssistant() {
        this.floatingAssistantOpen = !this.floatingAssistantOpen;
        if (this.floatingAssistantOpen) {
            this.syncFloatingProjectSelection();
            await this.loadFloatingOperatorOverview();
        }
        await this.service.render();
        if (this.floatingAssistantOpen) this.scrollFloatingConversation();
    }

    public async openFloatingAssistantRequest(message: string, projectId: string = '') {
        if (!this.isAdmin() || !message.trim()) return;
        this.floatingAssistantOpen = true;
        this.floatingAssistantMessage = message.trim();
        this.floatingAssistantError = '';
        if (projectId.trim()) this.floatingSelectedProjectId = projectId.trim();
        this.syncFloatingProjectSelection();
        await this.loadFloatingOperatorOverview();
        await this.service.render();
        this.scrollFloatingConversation();
    }

    public async newFloatingConversation() {
        if (this.floatingAssistantAsking) return;
        this.floatingConversationId = this.createFloatingConversationId();
        const projectId = this.floatingProjectId();
        if (projectId) this.floatingConversationByProject.set(projectId, this.floatingConversationId);
        this.floatingAssistantMessages = [];
        this.floatingAssistantMessage = '';
        this.floatingAttachments = [];
        this.floatingAssistantError = '';
        await this.service.render();
    }

    public async uploadFloatingAttachment(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        input.value = '';
        if (!file || this.floatingUploadingFile || this.floatingAttachments.length >= 5) return;
        this.floatingUploadingFile = true;
        this.floatingAssistantError = '';
        await this.service.render();
        try {
            const body = new FormData();
            body.set('file', file);
            const response = await fetch(this.operatorFileUrl, {
                method: 'POST', credentials: 'same-origin', cache: 'no-store',
                headers: { Accept: 'application/json' }, body
            });
            const payload = await this.readFloatingPayload(response);
            const error = this.floatingResponseError(response, payload, '파일을 업로드하지 못했습니다.');
            if (error) throw error;
            const attachment = this.unwrapFloatingPayload(payload);
            if (!attachment?.id) throw new Error('업로드한 파일 정보를 확인하지 못했습니다.');
            this.floatingAttachments.push(attachment);
        } catch (error: any) {
            this.floatingAssistantError = error?.message || '파일을 업로드하지 못했습니다.';
        } finally {
            this.floatingUploadingFile = false;
            await this.service.render();
        }
    }

    public async removeFloatingAttachment(attachmentId: string) {
        this.floatingAttachments = this.floatingAttachments.filter((item: any) => item?.id !== attachmentId);
        await this.service.render();
    }

    public async sendFloatingAssistant(event?: Event) {
        event?.preventDefault();
        const value = this.floatingAssistantMessage.trim();
        const requestAttachments = this.floatingAttachments.map((item: any) => ({ ...item }));
        if ((!value && !requestAttachments.length) || this.floatingAssistantAsking) return;
        const message = value || '첨부한 파일을 확인해서 현재 화면에 맞게 처리해줘.';
        const requestType = this.floatingResourceRequestType();
        const selectedModel = this.floatingModelOptions().some((item: any) => item.id === this.floatingSelectedModel)
            ? this.floatingSelectedModel : '';
        this.floatingAssistantAsking = true;
        this.floatingAssistantError = '';
        const exchange: any = {
            id: 'pending-' + Date.now(),
            request: message,
            attachments: requestAttachments,
            request_type: requestType,
            created_at: new Date().toISOString(),
            pending: true
        };
        this.floatingAssistantMessages.push(exchange);
        this.floatingAssistantMessage = '';
        this.floatingAttachments = [];
        await this.service.render();
        this.scrollFloatingConversation();
        try {
            const projectId = this.floatingProjectId();
            const projectQaContext = this.floatingProjectQaContext(projectId);
            const result = await this.postFloatingAsk({
                action: 'ask',
                message,
                model: selectedModel,
                request_type: requestType,
                conversation_id: this.floatingConversationId,
                page_context: this.floatingPageContext(),
                project_id: projectId,
                project_qa_context: projectQaContext,
                survey_id: this.floatingSurveyId(),
                harness_id: this.floatingHarnessId(),
                attachment_ids: requestAttachments.map((item: any) => item.id)
            });
            if (!result?.answer) throw new Error('운영 도우미가 답변을 반환하지 않았습니다.');
            this.floatingAssistantError = '';
            Object.assign(exchange, result, { pending: false });
            this.floatingConversationId = result.conversation_id || this.floatingConversationId;
            if (projectId) this.floatingConversationByProject.set(projectId, this.floatingConversationId);
            this.rememberFloatingExchange(exchange);
            this.notifyFloatingProjectResourceUpdated(result, projectId);
        } catch (error: any) {
            this.floatingAssistantMessages = this.floatingAssistantMessages.filter((item: any) => item !== exchange);
            this.floatingAssistantError = error?.message || '요청을 처리하지 못했습니다.';
            if (!this.floatingAssistantMessage) this.floatingAssistantMessage = value;
            if (!this.floatingAttachments.length) this.floatingAttachments = requestAttachments;
        } finally {
            this.floatingAssistantAsking = false;
            await this.service.render();
            this.scrollFloatingConversation();
        }
    }

    public floatingModelOptions(): any[] {
        const options = this.floatingOperatorOverview?.runtime?.available_models;
        return Array.isArray(options) ? options : [];
    }

    public floatingModelChoiceLabel(): string {
        const selected = this.floatingModelOptions().find((item: any) => item.id === this.floatingSelectedModel);
        return selected?.label || this.floatingOperatorOverview?.runtime?.model || '기본 모델';
    }

    public async toggleFloatingModelMenu() {
        this.floatingModelMenuOpen = !this.floatingModelMenuOpen;
        await this.service.render();
    }

    public async chooseFloatingModel(model: string) {
        if (model && !this.floatingModelOptions().some((item: any) => item.id === model)) return;
        this.floatingSelectedModel = model;
        this.floatingModelMenuOpen = false;
        try { window.localStorage.setItem('reviewops:selected-model', model); } catch (error) { /* storage is optional */ }
        window.dispatchEvent(new Event('reviewops:model-selection-changed'));
        await this.service.render();
    }

    private storedFloatingModel(): string {
        try { return window.localStorage.getItem('reviewops:selected-model') || ''; } catch (error) { return ''; }
    }

    public onFloatingComposerKeydown(event: KeyboardEvent) {
        if (event.key !== 'Enter' || event.shiftKey) return;
        if (event.isComposing || event.keyCode === 229) return;
        event.preventDefault();
        this.sendFloatingAssistant();
    }

    public async floatingProposalAction(action: 'apply' | 'rollback' | 'dismiss', exchange: any) {
        const proposal = exchange?.proposal;
        if (!proposal?.id || this.floatingAssistantActionId) return;
        this.floatingAssistantActionId = proposal.id + ':' + action;
        this.floatingAssistantError = '';
        try {
            const result = await this.postFloatingOperator({ action, proposal_id: proposal.id });
            exchange.proposal = result?.proposal || exchange.proposal;
            if (typeof result?.answer === 'string' && result.answer) exchange.answer = result.answer;
            if (typeof result?.severity === 'string' && result.severity) exchange.severity = result.severity;
            if (result?.direct_action) exchange.direct_action = result.direct_action;
            if (result?.overview && typeof result.overview === 'object') {
                this.floatingOperatorOverview = result.overview;
            }
            if (action === 'apply' || action === 'rollback') {
                this.notifyFloatingProjectResourceUpdated(result, this.floatingProjectId());
            }
            const nextUrl = action === 'apply' ? String(result?.proposal?.next_url || '') : '';
            if (nextUrl.startsWith('/review-projects/')) location.assign(nextUrl);
        } catch (error: any) {
            this.floatingAssistantError = error?.message || '승인 요청을 처리하지 못했습니다.';
        } finally {
            this.floatingAssistantActionId = '';
            await this.service.render();
        }
    }

    public floatingActionBusy(exchange: any, action: string) {
        return this.floatingAssistantActionId === exchange?.proposal?.id + ':' + action;
    }

    public openFloatingDirectAction(exchange: any) {
        const nextUrl = String(exchange?.direct_action?.next_url || '');
        if (
            ['/surveys', '/harnesses'].includes(nextUrl)
            || nextUrl.startsWith('/review-projects/')
            || nextUrl.startsWith('/api/v1/review-workspace/operator-file/')
        ) {
            location.assign(nextUrl);
        }
    }

    public floatingPageLabel() {
        const labels: any = {
            project_management: 'QA 프로젝트', survey_management: '설문지 관리',
            harness_management: '하네스 관리', entity_review: '개체명 검수', qa_review: 'QA 검수'
        };
        return labels[this.floatingPageContext()] || '검수 운영';
    }

    public showFloatingProjectSelector() {
        const path = location.pathname;
        return path === '/review-projects' || path.indexOf('/review-projects/') === 0;
    }

    public floatingProjectOptions() {
        const projects = this.floatingOperatorOverview?.projects;
        return Array.isArray(projects)
            ? projects.filter((project: any) => String(project?.id || '').trim() && String(project?.name || '').trim())
            : [];
    }

    public async onFloatingProjectChange() {
        this.floatingAssistantError = '';
        this.floatingAttachments = [];
        this.restoreFloatingProjectConversation();
        await this.service.render();
        this.scrollFloatingConversation();
    }

    public floatingRequestTypeLabel(value: string) {
        const labels: any = { auto: '자동 분석', lookup: '조회', execute: '실행', change: '변경안', development: '문제 개선' };
        return labels[value] || '자동 분석';
    }

    public floatingSeverityLabel(value: string) {
        return value === 'critical' ? '긴급' : value === 'warning' ? '주의' : '안내';
    }

    public floatingProposalKind(proposal: any) {
        const labels: any = {
            project_creation: '프로젝트 생성',
            project_deletion: '프로젝트 삭제',
            survey_creation: '설문지 생성',
            harness_creation: '하네스 생성',
            qa_generation: 'QA 실행', project_qa_settings: '생성 설정',
            harness_rules: '하네스 규칙', survey_content: '설문지 내용', development_request: '개발 요청'
        };
        return labels[proposal?.kind] || '승인 요청';
    }

    public floatingProposalStatus(status: string) {
        const labels: any = {
            pending: '승인 대기', completed: '처리 완료', applied: '적용됨', approved: '실행 승인',
            queued: '개발 대기', rolled_back: '되돌림', dismissed: '반려'
        };
        return labels[status] || status;
    }

    public floatingProposalActionLabel(proposal: any) {
        if (proposal?.kind === 'project_creation') return '프로젝트 생성';
        if (proposal?.kind === 'project_deletion') return '프로젝트 삭제';
        if (proposal?.kind === 'survey_creation') return '설문지 생성';
        if (proposal?.kind === 'harness_creation') return '하네스 생성';
        if (proposal?.kind === 'qa_generation') return 'QA 생성 시작';
        if (proposal?.kind === 'development_request') return '개발 요청 등록';
        return '적용';
    }

    public floatingProposalActionIcon(proposal: any) {
        return proposal?.kind === 'project_deletion' ? 'fa-trash-can' : 'fa-check';
    }

    private floatingPageContext() {
        const path = location.pathname;
        if (path === '/surveys' || path.indexOf('/surveys/') === 0) return 'survey_management';
        if (path === '/harnesses' || path.indexOf('/harnesses/') === 0) return 'harness_management';
        if (path === '/entity-reviews' || path.indexOf('/entity-reviews/') === 0) return 'entity_review';
        if (path === '/human-reviews' || path.indexOf('/human-reviews/') === 0 || /^\/review-tasks\/qa\//.test(path)) return 'qa_review';
        return 'project_management';
    }

    private floatingProjectId() {
        if (this.showFloatingProjectSelector()) {
            return String(this.floatingSelectedProjectId || '').trim();
        }
        return this.floatingRouteProjectId();
    }

    private floatingProjectQaContext(projectId: string) {
        if (!projectId) return undefined;
        const detail: any = { project_id: projectId, project_qa_context: undefined };
        window.dispatchEvent(new CustomEvent('reviewops:project-context-request', { detail }));
        const context = detail.project_qa_context;
        return context && typeof context === 'object' ? context : undefined;
    }

    private floatingRouteProjectId() {
        const matched = location.pathname.match(/^\/review-projects\/(RV-[A-Za-z0-9._:-]+)/);
        return matched ? matched[1] : '';
    }

    private syncFloatingProjectSelection() {
        const options = this.floatingProjectOptions();
        const selected = String(this.floatingSelectedProjectId || '').trim();
        if (selected && (!options.length || options.some((project: any) => project.id === selected))) return;
        const routeProjectId = this.floatingRouteProjectId();
        this.floatingSelectedProjectId = (
            routeProjectId && (!options.length || options.some((project: any) => project.id === routeProjectId))
        ) ? routeProjectId : '';
    }

    private floatingHarnessId() {
        const matched = location.pathname.match(/^\/harnesses\/(HN-[A-Za-z0-9._:-]+)/)
            || location.pathname.match(/^\/review-projects\/[^/]+\/resource-editor\/harness\/(HN-[A-Za-z0-9._:-]+)/);
        return matched ? matched[1] : '';
    }

    private floatingSurveyId() {
        const matched = location.pathname.match(/^\/surveys\/(SV-[A-Za-z0-9._:-]+)/)
            || location.pathname.match(/^\/review-projects\/[^/]+\/resource-editor\/survey\/(SV-[A-Za-z0-9._:-]+)/);
        return matched ? matched[1] : '';
    }

    private floatingResourceRequestType() {
        return this.floatingSurveyId() || this.floatingHarnessId() ? 'execute' : 'auto';
    }

    private async loadFloatingOperatorOverview() {
        this.floatingAssistantLoading = true;
        try {
            const response = await fetch(this.operatorUrl, {
                method: 'GET', credentials: 'same-origin', cache: 'no-store',
                headers: { Accept: 'application/json' }
            });
            const payload = await this.readFloatingPayload(response);
            const error = this.floatingResponseError(response, payload, '운영 도우미를 불러오지 못했습니다.');
            if (error) throw error;
            this.floatingOperatorOverview = this.unwrapFloatingPayload(payload);
            this.syncFloatingProjectSelection();
            this.restoreFloatingProjectConversation();
        } catch (error: any) {
            this.floatingAssistantError = error?.message || '운영 도우미를 불러오지 못했습니다.';
        } finally {
            this.floatingAssistantLoading = false;
        }
    }

    private notifyFloatingProjectResourceUpdated(result: any, projectId: string) {
        const kind = String(result?.direct_action?.kind || '');
        const resourceKind: any = {
            harness_creation: 'harness', harness_connection: 'harness',
            survey_creation: 'survey', survey_connection: 'survey',
            harness_rename: 'harness', survey_rename: 'survey', project_rename: 'project',
            harness_update: 'harness', survey_update: 'survey'
        }[kind];
        const affectedProjectId = String(result?.direct_action?.project_id || projectId || '');
        if (!affectedProjectId || !resourceKind) return;
        const renamedProject = resourceKind === 'project'
            ? this.floatingProjectOptions().find((project: any) => project.id === affectedProjectId)
            : null;
        if (renamedProject && result?.direct_action?.name) renamedProject.name = result.direct_action.name;
        window.dispatchEvent(new CustomEvent('reviewops:project-resource-updated', {
            detail: {
                kind: resourceKind,
                project_id: affectedProjectId,
                resource_id: String(result?.direct_action?.target_id || '')
            }
        }));
    }

    private rememberFloatingExchange(exchange: any) {
        const activity = Array.isArray(this.floatingOperatorOverview?.activity)
            ? this.floatingOperatorOverview.activity
            : [];
        const activityId = String(exchange?.activity_id || exchange?.id || '');
        if (activityId && !activity.some((item: any) => String(item?.id || '') === activityId)) {
            activity.unshift({
                ...exchange,
                id: activityId,
                type: 'assistant.response',
                conversation_id: this.floatingConversationId
            });
            this.floatingOperatorOverview.activity = activity.slice(0, 500);
        }
        if (exchange?.proposal?.id) {
            const proposals = Array.isArray(this.floatingOperatorOverview?.proposals)
                ? this.floatingOperatorOverview.proposals
                : [];
            if (!proposals.some((proposal: any) => proposal?.id === exchange.proposal.id)) {
                proposals.unshift(exchange.proposal);
                this.floatingOperatorOverview.proposals = proposals;
            }
        }
    }

    private restoreFloatingProjectConversation() {
        const projectId = this.floatingProjectId();
        if (!projectId) {
            this.floatingAssistantMessages = [];
            this.floatingConversationId = this.createFloatingConversationId();
            return;
        }
        const rows = (Array.isArray(this.floatingOperatorOverview?.activity)
            ? this.floatingOperatorOverview.activity
            : []).filter((item: any) => (
            item?.type === 'assistant.response'
            && this.floatingActivityProjectId(item) === projectId
            && this.floatingActivityBelongsToProjectLifetime(item, projectId)
        ));
        let conversationId = this.floatingConversationByProject.get(projectId) || '';
        if (
            conversationId
            && !rows.some((item: any) => String(item?.conversation_id || '') === conversationId)
        ) conversationId = '';
        if (!conversationId) conversationId = String(rows[0]?.conversation_id || '');
        if (!conversationId) conversationId = this.createFloatingConversationId();
        this.floatingConversationByProject.set(projectId, conversationId);
        this.floatingConversationId = conversationId;
        const proposals = Array.isArray(this.floatingOperatorOverview?.proposals)
            ? this.floatingOperatorOverview.proposals
            : [];
        this.floatingAssistantMessages = rows
            .filter((item: any) => String(item?.conversation_id || 'CHAT-legacy') === conversationId)
            .reverse()
            .map((item: any) => ({
                id: item.id,
                request: item.request,
                request_type: item.request_type || 'auto',
                attachments: Array.isArray(item.attachments) ? item.attachments : [],
                created_at: item.created_at,
                pending: false,
                answer: item.answer,
                severity: item.severity || 'info',
                findings: Array.isArray(item.findings) ? item.findings : [],
                direct_action: item.direct_action || null,
                proposal: item.proposal_id
                    ? proposals.find((proposal: any) => proposal?.id === item.proposal_id) || null
                    : null
            }));
    }

    private floatingActivityProjectId(item: any) {
        const context = Array.isArray(item?.request_context) ? item.request_context : [];
        const project = context.find((entry: any) => entry?.kind === 'project' && entry?.selected);
        return String(project?.id || item?.direct_action?.project_id || '');
    }

    private floatingActivityBelongsToProjectLifetime(item: any, projectId: string) {
        const project = this.floatingProjectOptions().find((entry: any) => String(entry?.id || '') === projectId);
        const projectCreatedAt = Date.parse(String(project?.created_at || project?.createdAt || ''));
        const activityCreatedAt = Date.parse(String(item?.completed_at || item?.created_at || ''));
        if (!Number.isFinite(projectCreatedAt) || !Number.isFinite(activityCreatedAt)) return true;
        return activityCreatedAt >= projectCreatedAt;
    }

    private async pollOperatorNotifications() {
        try {
            const response = await fetch(this.operatorUrl, {
                method: 'GET', credentials: 'same-origin', cache: 'no-store',
                headers: { Accept: 'application/json' }
            });
            const payload = await this.readFloatingPayload(response);
            if (!response.ok) return;
            const overview = this.unwrapFloatingPayload(payload);
            const incoming = Array.isArray(overview?.notifications) ? overview.notifications : [];
            if (!this.showOperatorNotifications()) {
                this.operatorNotifications = [];
                for (const notification of incoming) {
                    if (!notification?.id) continue;
                    try {
                        await this.postFloatingOperator({
                            action: 'ack_notification', notification_id: notification.id
                        });
                    } catch (error) {
                        continue;
                    }
                }
                return;
            }
            let changed = false;
            for (const notification of incoming) {
                if (!notification?.id || this.operatorNotifications.some((item: any) => item.id === notification.id)) continue;
                this.operatorNotifications.push(notification);
                changed = true;
                const timer = window.setTimeout(() => void this.dismissOperatorNotification(notification), 8000);
                this.notificationDismissTimers.set(notification.id, timer);
            }
            if (changed) {
                this.operatorNotifications = this.operatorNotifications.slice(-4);
                await this.service.render();
            }
        } catch (error) {
            return;
        }
    }

    private async postFloatingOperator(payload: any) {
        const body = new URLSearchParams();
        body.set('payload', JSON.stringify(payload));
        const response = await fetch(this.operatorUrl, {
            method: 'POST', credentials: 'same-origin', cache: 'no-store',
            headers: { Accept: 'application/json' }, body
        });
        const responsePayload = await this.readFloatingPayload(response);
        const error = this.floatingResponseError(response, responsePayload, '요청을 처리하지 못했습니다.');
        if (error) throw error;
        return this.unwrapFloatingPayload(responsePayload);
    }

    private async postFloatingAsk(payload: any) {
        const compactPayload = Object.keys(payload || {}).reduce((result: any, key: string) => {
            const value = payload[key];
            if (value !== undefined && value !== null && value !== '') result[key] = value;
            return result;
        }, {});
        try {
            return await this.postFloatingOperator(compactPayload);
        } catch (error: any) {
            const invalidAction = error?.code === 'INVALID_OPERATOR_ACTION'
                || String(error?.message || '').includes('운영 도우미 작업이 올바르지 않습니다');
            if (!invalidAction || !Object.prototype.hasOwnProperty.call(compactPayload, 'project_qa_context')) {
                throw error;
            }
            const compatibilityPayload = { ...compactPayload };
            delete compatibilityPayload.project_qa_context;
            return await this.postFloatingOperator(compatibilityPayload);
        }
    }

    private async readFloatingPayload(response: Response) {
        try { return await response.json(); } catch (error) { return null; }
    }

    private unwrapFloatingPayload(payload: any) {
        const candidates = [payload?.data?.data, payload?.data, payload?.result, payload];
        return candidates.find((item: any) => item && typeof item === 'object') || {};
    }

    private floatingResponseError(response: Response, payload: any, fallback: string) {
        const code = Number(payload?.code ?? response.status);
        if (response.ok && (!Number.isFinite(code) || code < 400)) return null;
        const error: any = new Error(payload?.message || payload?.data?.message || fallback);
        error.code = String(payload?.error?.code || payload?.data?.code || payload?.code || '');
        error.status = response.status;
        return error;
    }

    private scrollFloatingConversation() {
        requestAnimationFrame(() => {
            const element = document.querySelector('.floating-ai__conversation');
            if (element) element.scrollTop = element.scrollHeight;
        });
    }

    private createFloatingConversationId() {
        const values = new Uint32Array(2);
        window.crypto.getRandomValues(values);
        return `CHAT-float-${Date.now().toString(36)}-${values[0].toString(36)}${values[1].toString(36)}`;
    }

    private taskKind(task: any) {
        return String(task?.kind || task?.type || task?.outputType || task?.output_type || '').toLowerCase();
    }

    private normalizeWorkspaceState(payload: any) {
        const candidates = [
            payload?.data?.data?.state,
            payload?.data?.state,
            payload?.data?.data,
            payload?.result?.state,
            payload?.state,
            payload?.result,
            payload?.data,
            payload
        ];
        const state = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && (
                Object.prototype.hasOwnProperty.call(candidate, 'schema_version')
                || Object.prototype.hasOwnProperty.call(candidate, 'projects')
                || Object.prototype.hasOwnProperty.call(candidate, 'surveys')
                || Object.prototype.hasOwnProperty.call(candidate, 'harnesses')
                || Object.prototype.hasOwnProperty.call(candidate, 'tasks')
                || Object.prototype.hasOwnProperty.call(candidate, 'evaluations')
            ));
        if (!state) return null;
        const rows = (value: any) => Array.isArray(value)
            ? value
            : (value && typeof value === 'object' ? Object.values(value) : []);
        return Object.assign({}, state, {
            projects: rows(state.projects),
            surveys: rows(state.surveys),
            harnesses: rows(state.harnesses),
            tasks: rows(state.tasks),
            evaluations: state.evaluations && typeof state.evaluations === 'object' && !Array.isArray(state.evaluations)
                ? state.evaluations
                : {}
        });
    }

    private async loadWorkspaceCounts() {
        try {
            const response = await fetch(this.workspaceStateUrl, {
                method: 'GET',
                credentials: 'same-origin',
                cache: 'no-store',
                headers: { Accept: 'application/json' }
            });
            if (!response.ok) {
                this.resetWorkspaceCounts();
                return;
            }
            const payload = await response.json();
            const state = this.normalizeWorkspaceState(payload);
            if (!state || typeof state !== 'object' || !Array.isArray(state.tasks)) {
                this.resetWorkspaceCounts();
                return;
            }
            const tasks = state.tasks.filter((task: any) => {
                const status = String(task?.status || '').toLowerCase();
                return ['cancelled', 'canceled', 'deleted'].indexOf(status) < 0;
            });
            this.projectCount = Array.isArray(state.projects) ? state.projects.length : 0;
            this.qaTaskCount = tasks.filter((task: any) => this.taskKind(task).indexOf('qa') >= 0).length;
            this.kgTaskCount = tasks.filter((task: any) => this.taskKind(task).indexOf('kg') >= 0).length;
        } catch (error) {
            this.resetWorkspaceCounts();
        }
    }

    private resetWorkspaceCounts() {
        this.projectCount = 0;
        this.qaTaskCount = 0;
        this.kgTaskCount = 0;
    }

    private async loadEntityCounts() {
        try {
            const data = await EntityApi.request('overview');
            this.entityProjectCount = data.projects.length;
            this.entityTaskCount = data.projects.filter((p: any) => p.active_run && p.progress < 100).length;
        } catch (error) { this.entityProjectCount = 0; this.entityTaskCount = 0; }
        await this.service.render();
    }

    public isAdmin() {
        return this.service.auth.check.role('admin');
    }

    public displayName() {
        return this.service.auth.session?.name || '사용자';
    }

    public displayEmail() {
        return this.service.auth.session?.email || '';
    }

    public initial() {
        const name = this.displayName();
        return name ? name.charAt(0) : '사';
    }

    public roleLabel() {
        return this.isAdmin() ? 'ADMIN' : '검수자';
    }

    public roleBadgeClass() {
        return this.isAdmin()
            ? 'role-badge--admin'
            : 'role-badge--user';
    }

    public isActive(link: string) {
        const path = location.pathname;
        return path === link || path.indexOf(link + '/') === 0;
    }

    public activeClass(link: string) {
        const base = 'nav-link group flex min-h-[42px] items-center gap-3 rounded-xl px-3 text-[13px] font-semibold transition-all';
        return this.navClass(base, this.isActive(link));
    }

    public reviewProjectClass() {
        const base = 'nav-link group flex min-h-[42px] items-center gap-3 rounded-xl px-3 text-[13px] font-semibold transition-all';
        const path = location.pathname;
        const active = this.isActive('/review-projects') && !/\/review-projects\/[^/]+\/samples$/.test(path);
        return this.navClass(base, active);
    }

    public qaReviewClass() {
        const base = 'nav-link group flex min-h-[42px] items-center gap-3 rounded-xl px-3 text-[13px] font-semibold transition-all';
        const path = location.pathname;
        const active = this.isActive('/human-reviews') || /^\/review-tasks\/qa\//.test(path);
        return this.navClass(base, active);
    }

    public kgReviewClass() {
        const base = 'nav-link group flex min-h-[42px] items-center gap-3 rounded-xl px-3 text-[13px] font-semibold transition-all';
        const path = location.pathname;
        const active = this.isActive('/kg-reviews') || /^\/review-tasks\/kg\//.test(path);
        return this.navClass(base, active);
    }

    private navClass(base: string, active: boolean) {
        if (active) {
            return base + ' nav-link--active';
        }
        return base + ' nav-link--idle';
    }
}

export default ComponentNavSidebarComponent;